import { createContext, useContext } from 'react';

/**
 * How the assistant's own content reaches whatever is hosting it.
 *
 * The assistant is a modal, and a link followed from inside one navigates the
 * page behind it: the modal stays up, so the destination looks nested in the
 * assistant and is only revealed when the assistant is closed. Anything in
 * here that navigates closes the host first, through this.
 */
export const AssistantHost = createContext<{ dismiss?: () => void }>({});

/**
 * Closes the assistant, when it is in something that closes.
 *
 * Undefined where the assistant is the page rather than a modal, so callers
 * can hand it straight to `onClick` either way.
 */
export function useAssistantDismiss(): (() => void) | undefined {
  return useContext(AssistantHost).dismiss;
}
